import { React, reduxConnect } from '../lib/imports';
import Stepper, { Step } from '../common/stepper';
import QuizApp from '../onboarding/QuizApp';
import NameEntry from '../onboarding/NameEntry';
import Success from '../onboarding/Success';
import { setCompletedOnboarding } from '../onboarding/actions';
import Notifications from '../onboarding/Notifications';
import { isSkillTestingLocked, shouldAllowPlay } from '../stq/platformQuestion';

export const resolveOnboardingStep = ({ hasAnswered, hasUsername, hasNotificationPref, platformQuestion }) => {
  if (!hasAnswered && !shouldAllowPlay(platformQuestion?.outcome)) {
    return 0;
  }
  if (!hasUsername) {
    return 1;
  }
  if (!hasNotificationPref) {
    return 2;
  }
  return 3;
};

const Onboarding = ({
  quizText,
  usernameText,
  notificationsText,
  doneText,
  initialStep,
  hideProgress,
  handleOnboardingComplete,
  ...props
}) => {
  return (
    <Stepper initialStep={initialStep} hideProgress={hideProgress}>
      <Step bannerText={quizText}>
        <QuizApp />
      </Step>
      <Step bannerText={usernameText}>
        <NameEntry />
      </Step>
      <Step bannerText={notificationsText}>
        <Notifications {...props} />
      </Step>
      <Step bannerText={doneText}>
        <Success />
      </Step>
    </Stepper>
  );
};

const mapStateToProps = (state) => {
  const { strings, onboarding, config } = state;
  const { hasAnswered, hasUsername, hasNotificationPref, platformQuestion, lockout } = onboarding;

  return {
    initialStep: resolveOnboardingStep({ hasAnswered, hasUsername, hasNotificationPref, platformQuestion }),
    hideProgress: isSkillTestingLocked({ lockout, platformQuestion }),
    quizText: strings['titles/onboarding/quiz/text'],
    usernameText: strings['titles/onboarding/username/text'],
    notificationsText: strings['titles/onboarding/notifications/text'],
    doneText: strings['titles/onboarding/done/text'],
    config: config,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleOnboardingComplete: (config) => dispatch(setCompletedOnboarding(config)),
  };
};

export default reduxConnect(mapStateToProps, mapDispatchToProps)(Onboarding);
